import { useCallback, useEffect, useRef } from 'react';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { containsNode } from '../utils/dom';
function getDropdownLaunchpad() {
  return Array.from(document.body.childNodes).find(function (el) {
    return el.dataset && 'dropdownLaunchpad' in el.dataset;
  }) || null;
}
export var useScrollLock = function useScrollLock(target) {
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var recalculateIgnore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var allowedScroll = useRef([]);
  var dropdownLaunchpad = useRef(null);
  var elementsCache = useRef(new Map());
  var allowTouchMove = useCallback(function (el) {
    if (elementsCache.current.has(el)) {
      return elementsCache.current.get(el);
    }
    if (dropdownLaunchpad.current && containsNode(dropdownLaunchpad.current, el)) {
      elementsCache.current.set(el, true);
      return true;
    }
    if (allowedScroll.current.length === 0) {
      return;
    }
    return allowedScroll.current.some(function (scr) {
      var result = containsNode(scr, el);
      elementsCache.current.set(el, result);
      return result;
    });
  }, []);
  useEffect(function () {
    dropdownLaunchpad.current = getDropdownLaunchpad();
    if (dropdownLaunchpad.current) {
      return;
    }
    var observer = new MutationObserver(function () {
      dropdownLaunchpad.current = getDropdownLaunchpad();
      if (dropdownLaunchpad.current) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true
    });
    return function () {
      observer.disconnect();
    };
  }, []);
  useEffect(function () {
    var _a;
    allowedScroll.current = Array.from(((_a = target.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[data-scroll-lock-ignore]')) || []);
  }, [target.current, recalculateIgnore]);
  useEffect(function () {
    var node = target.current;
    if (enabled && node) {
      disableBodyScroll(node, {
        allowTouchMove: allowTouchMove
      });
    }
    return function () {
      if (node) {
        enableBodyScroll(node);
      }
    };
  }, [target.current, enabled]);
};